import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from './authSlice';
import accountReducer from './accountSlice';
import groupReducer from './groupSlice';
import instanceReducer from './instanceSlice';
import haInstanceReducer from './haInstanceSlice';
import instanceExtraReducer from './instanceExtraSlice';
import instanceStateReducer from './instanceStateSlice';
import assetReducer from './assetSlice';
import sidemenuReducer from './sidemenuSlice';
import fcOU from './fcOuSlice';
import snpashotReducer from './snapshotSlice';
import { globalApi } from '../services/globalApi';
import { regionApi } from '../services/regionApi';

export function setUpStore() {
  const store = configureStore({
    reducer: {
      [globalApi.reducerPath]: globalApi.reducer,
      [regionApi.reducerPath]: regionApi.reducer,
      auth: authReducer,
      account: accountReducer,
      group: groupReducer,
      haInstance: haInstanceReducer,
      instance: instanceReducer,
      instanceExtra: instanceExtraReducer,
      instanceState: instanceStateReducer,
      asset: assetReducer,
      sidemenu: sidemenuReducer,
      fcOU: fcOU,
      snapshot: snpashotReducer
    },
    middleware: (gDM) =>
      gDM({ serializableCheck: false }).concat(
        globalApi.middleware,
        regionApi.middleware
      )
  });
  setupListeners(store.dispatch);

  return store;
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const store = setUpStore();
